import script from "./FriendshipLink.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendshipLink.vue?vue&type=script&setup=true&lang=js"

import "./FriendshipLink.vue?vue&type=style&index=0&id=b3292590&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3292590"]])

export default __exports__